<template>
    <div class="HighSchoolForm relative space-y-5">
        <CFormGroup label="Názov strednej školy">
            <CFormInput
                :disabled="disabled"
                :has-suffix="$attrs['hasSuffix']"
                :suffix-icon="$attrs['suffixIcon']"
                :model-value="modelValue.school"
                @update:model-value="update({ school: $event })"
            />
        </CFormGroup>

        <CFormGroup label="Mesto">
            <CFormInput
                :disabled="disabled"
                :has-suffix="$attrs['hasSuffix']"
                :suffix-icon="$attrs['suffixIcon']"
                :model-value="modelValue.address"
                @update:model-value="update({ address: $event })"
            />
        </CFormGroup>

        <YearsRangeInput
            :disabled="disabled"
            end-label="Rok ukončenia štúdia"
            :end-year="modelValue.endYear"
            start-label="Rok začatia štúdia"
            :start-year="modelValue.startYear"
            @change="update($event)"
        />

        <CFormGroup label="Popis">
            <CWysiwyg
                :allowed-buttons="['back', 'forward', 'bold', 'italic', 'strike', 'orderedList', 'bulletList']"
                :disabled="disabled"
                :model-value="modelValue.desc"
                @update:model-value="update({ desc: $event })"
            />
        </CFormGroup>
    </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

import type { School } from '#shared/types/User'
import YearsRangeInput from '@/components/profile/YearsRangeInput.vue'
import CFormGroup from '@/components/ui/CFormGroup.vue'
import CFormInput from '@/components/ui/CFormInput.vue'
import CWysiwyg from '@/components/ui/CWysiwyg.vue'

const props = defineProps({
    modelValue: {
        type: Object as PropType<School>,
        default: () => ({})
    },
    disabled: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['update:modelValue'])

function update(change: Partial<School>) {
    emit('update:modelValue', { ...props.modelValue, ...change })
}
</script>